(function ($) {

    $(document).ready(function () {
        var url = window.location.href;
        var encodedUrl = encodeURIComponent(url);
        changeRedirection(encodedUrl);
    });

    $(window).on('hashchange', function (e) {
        var url = window.location.href;
        var encodedUrl = encodeURIComponent(url);
        changeRedirection(encodedUrl);
    });

    function changeRedirection(e) {

        if ($(".nav-lines-brands li a").length) {
            $(".nav-lines-brands li a").each(function () {                
                    if ($(this).attr("href") != undefined) {
                        var navLineBrands = $(this).attr("href");
                        var beginingNavLine = navLineBrands.split("=")[0] + "=";
                        var endNavLine = "";
                        if (navLineBrands.split("#").length > 1) {
                            for (var i = 1; i <= navLineBrands.split("#").length; i++) {
                                if (navLineBrands.split("#")[i] != undefined && navLineBrands.split("#")[i] != null) {
                                    endNavLine = endNavLine + "#" + navLineBrands.split("#")[i];
                                }
                            }
                            var finalNavLine = $(this).attr("href", beginingNavLine + e + endNavLine);
                        }
                    }

            });
        }

        if ($(".nav-country li a").length) {
            $(".nav-country li a").each(function () {
                var pageUrl = window.location.href;
                if (pageUrl.charAt(pageUrl.length - 1) != '#'){
                    if ($(this).attr("href") != undefined) {
                        if ($(this).attr("class") !== 'country-selector') {
                            var navCountry = $(this).attr("href");
                            var beginingNavCountry = navCountry.split("=")[0] + "=";
                            var endNavCountry = "";
                            if (navCountry.split("#").length > 1) {
                                for (var i = 1; i <= navCountry.split("#").length; i++) {
                                    if (navCountry.split("#")[i] != undefined && navCountry.split("#")[i] != null) {
                                        endNavCountry = endNavCountry + "#" + navCountry.split("#")[i];
                                    }
                                }
                                var finalnavCountry = $(this).attr("href", beginingNavCountry + e + endNavCountry);

                            }
                        }
                    }
                }               
            });
        }


    }

}(window.jQuery));

// Analytics for HeaderLinks.cshtml
analytics.eventConfig.push({
    "target": "ul.nav-lines-brands:not(ul.component.link-list.nav-lines-brands)",
    "codeId": "hl",
    "events": [
        {
            "eventTarget": "a",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "elementText": "",
                "componentId": "hl",
                "componentName": "header link",
                "destinationUrl": "",
                "elementType": "header link",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "header link outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "header link internal navigation click"
                    }
                ],
                "parentName": ""
            }
        }

    ]
}, 
{// Analytics for CountrySelector.cshtml
    "target": ".nav-country",
    "codeId": "cs",
    "events": [
        {
            "eventTarget": "a",
            "eventType": "click",
            "tags": {
                "event": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "outbound"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "componentName": "country selector",
                "componentId": "cs",
                "eventType": [
                    {
                        "rule": "$(context).prop('hostname') !== window.location.hostname",
                        "value": "country selector outbound click"
                    },
                    {
                        "rule": "true",
                        "value": "country selector internal navigation click"
                    }
                ],
                "elementType": "country selector",
                "elementText": "",
                "destinationUrl": "",
                "parentName": ""
            }
        }

    ]
});